import { useTranslation } from 'react-i18next'
import { useWeb3React } from '@web3-react/core'
import { useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import { StyledExchangeBtn } from './styled'
import { useGA } from '~/hooks'
import { ReactComponent as IconLoading } from '~/assets/images/ellipse.svg'
import styled from 'styled-components'
import { motion } from 'framer-motion'

interface Props {
  loading: boolean
  handleExchange: fn
  text?: string
  disabled?: boolean
}

const ExchangeButton = ({
  handleExchange,
  text,
  disabled = false,
  loading,
}: Props) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const isWalletConnected = !!account
  const { trackElClickCurring } = useGA()
  const toggleWalletModal = useModalToggle(ApplicationModal.WALLET_CONNECT)
  const textLabel = text || t('confirm')

  return (
    <StyledExchangeBtn
      className="exchange-btn"
      data-trackid="webtl_walletconnect"
      data-trackdata={JSON.stringify({ from: 'instant' })}
      disabled={disabled || loading}
      onClick={
        isWalletConnected
          ? handleExchange
          : (e) => trackElClickCurring(e)(toggleWalletModal)
      }
    >
      {loading && (
        <StyledMotion
          animate={{ rotate: [0, 360] }}
          transition={{
            duration: 1,
            ease: 'linear',
            origin: 'center',
            repeat: Infinity,
          }}
        >
          <IconLoading fill="#fff" />
        </StyledMotion>
      )}
      {!loading && (!isWalletConnected ? t('connect') : textLabel)}
    </StyledExchangeBtn>
  )
}

export default ExchangeButton
const StyledMotion = styled(motion.div)`
  width: 18px;
  height: 18px;
`
